import React, { useEffect, useState } from "react";
import { decryptData } from "../../utils/crypto";
import { ChevronLeft, Shop, Trash3 } from "react-bootstrap-icons";
import { useNavigate, useParams } from "react-router-dom";
import {
  createProducts,
  getProductsDetails,
  updateProducts,
} from "../../services/productServices";
import Utils from "../../utils";
import {
  getAllUnitsList,
  getAllCategoryList,
  getAllCustomerStoreList,
} from "../../services/commonServices";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { customStyles } from "../../utils/function";
import { notify } from "../../components/Common/Alerts";
import { useConfig } from "../../components/Context/ConfigContext";
import {
  createVendors,
  getVendorsDetails,
  updateVendors,
} from "../../services/vendorService";
import CONFIG from "../../config";

const AddVendor = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const storedData = JSON.parse(localStorage.getItem(CONFIG.login_data));
console.log("storedData",storedData)

  const [formData, setFormData] = useState({
    vendor_name: "",
    email: "",
    mobile: "",
    store_id: Number(storedData?.active_store_id) || "",
    contact_person: "",
    payment_terms: "",
    gst_number: "",
    status: 1,
    uuid: "",
    vendor_type: "",
  });
console.log("formData",formData)


  const [errors, setErrors] = useState({
    vendor_name: "",
    email: "",
    store_id: "",
    contact_person: "",
    vendor_type: "",
  });
  const [btnLoading, setBtnLoading] = useState(false);
  const [vendorDetails, setVendorDetails] = useState("");
  const [storeList, setStoreList] = useState([]);

  const { configData } = useConfig();
  const vendorTypeOptions = configData?.VENDOR_TYPE?.map((item) => ({
    label: item,
    value: item,
  }));

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const data = { search: "" };
        const response = await getAllCustomerStoreList(data);

        const decrypted = decryptData(response.data.data);
        const dataList = decrypted.data || [];

        const storeOptions = dataList.map((store) => ({
          label: store.name,
          value: store.id,
        }));

        setStoreList(storeOptions);
      } catch (err) {
        notify.error(Utils.getErrorMessage(err));
      }
    };
    fetchStores();
  }, []);

  const validateField = (name, value) => {
    switch (name) {
      case "vendor_name":
        if (!value) return "Vendor name is required";
        return "";
      case "store_id":
        if (!value) return "Store is required";
        return "";

      case "vendor_type":
        if (!value) return "Vendor type is required";
        return "";

      case "contact_person":
        if (!value) return "Contact person is required";
        return "";

      case "mobile":
        if (!value) return t("mobileIsRequired");
        const mobileRegex = /^\d{10}$/;
        if (!mobileRegex.test(value)) {
          return t("enterDigitMobileNumber");
        }
        return "";

      case "email":
        if (!value?.trim()) return "Email is required";
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(value)) return t("pleaseEnterValidEmail");
        return "";

      default:
        return "";
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, value),
    }));
  };

  useEffect(
    function () {
      if (uuid) {
        let data = {
          uuid: uuid,
        };
        getVendorsDetails(data)
          .then((response) => {
            const decrypted = decryptData(response.data.data);
            setVendorDetails(decrypted.data);
          })
          .catch((err) => {
            notify.error(Utils.getErrorMessage(err));
          });
      }
    },
    [navigate, uuid],
  );

  useEffect(
    function () {
      if (vendorDetails) {
        setFormData({
          vendor_name: vendorDetails?.vendor_name,
          email: vendorDetails?.email,
          mobile: vendorDetails?.mobile,
          store_id: vendorDetails?.store_id,
          contact_person: vendorDetails?.contact_person,
          status: vendorDetails?.status,
          vendor_type: vendorDetails?.vendor_type,
          uuid: vendorDetails?.uuid,
          contact_person: vendorDetails?.contact_person,
          payment_terms: vendorDetails?.payment_terms,
          gst_number: vendorDetails?.gst_number,
        });
      }
    },
    [vendorDetails],
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {
      vendor_name: validateField("vendor_name", formData.vendor_name),
      email: validateField("email", formData.email),
      vendor_type: validateField("vendor_type", formData.vendor_type),
      mobile: validateField("mobile", formData.mobile),
      store_id: validateField("store_id", formData.store_id),
      contact_person: validateField("contact_person", formData.contact_person),
    };

    Utils.focusError();
    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some((err) => err);
    if (hasErrors) return;

    if (!newErrors.name) {
      setBtnLoading(true);
      const payload = {
        vendor_name: formData.vendor_name,
        email: formData.email,
        mobile: formData.mobile,
        status: formData.status,
        vendor_type: formData.vendor_type,
        contact_person: formData.contact_person,
        payment_terms: formData.payment_terms,
        gst_number: formData.gst_number,
        store_id: formData.store_id,
        ...(formData?.uuid && { uuid: formData.uuid }),
      };
      const apiCall = formData?.uuid ? updateVendors : createVendors;

      try {
        const response = await apiCall(payload);
        const decrypted = decryptData(response.data.data);
        notify.success(decrypted.message);
        setFormData({
          vendor_name: "",
          email: "",
          mobile: "",
          store_id: "",
          contact_person: "",
          payment_terms: "",
          gst_number: "",
          status: 1,
          uuid: "",
          vendor_type: "",
        });
        setErrors("");
        navigate("/vendor");
      } catch (err) {
        notify.error(Utils.getErrorMessage(err));
      } finally {
        setBtnLoading(false);
      }
    }
  };

  return (
    <div className="w-full px-4 md:px-6 pb-10">
      {/* --- HEADER --- */}
      <div className="hidden md:flex flex items-center gap-4 md:gap-6 flex-shrink-0 px-2 mb-2">
        <button
          onClick={() => navigate("/vendor")}
          className="md:hidden group flex items-center justify-center w-10 h-10 md:w-auto md:h-auto md:px-4 md:py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 transition-all active:scale-95 shadow-sm"
        >
          <ChevronLeft
            size={18}
            className="group-hover:-translate-x-1 transition-transform md:hidden"
          />
          <span className="hidden md:block ml-2 font-bold text-sm">
            {t("back")}
          </span>
        </button>

        <div className="flex-1 hidden md:block">
          <h2 className="text-xl md:text-2xl font-black text-slate-800 dark:text-white tracking-tight leading-tight">
            {uuid ? t("updateVendor") : t("addVendor")}{" "}
          </h2>
        </div>
      </div>

      <section className="w-full bg-white dark:bg-slate-900 rounded-[45px] border border-slate-100 p-6 md:p-10 lg:p-14 shadow-sm">
        <div className="flex items-center justify-between mb-12">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-brand-orange/10 text-brand-orange rounded-2xl flex items-center justify-center">
              <Shop size={24} />
            </div>
            <h2 className="text-xl font-black text-slate-800">
              {t("vendorDetails")}{" "}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6">
          {" "}
          <div className="flex flex-col gap-2">
            <label htmlFor="name" className="input-label">
              {t("vendorName")} <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="vendor_name"
              placeholder={t("enterVendorName")}
              className={`input-field ${errors.vendor_name ? "input-error" : ""}`}
              value={formData?.vendor_name || ""}
              onChange={handleChange}
              maxLength={50}
            />
            {errors.vendor_name && (
              <span className="text-danger">{errors.vendor_name}</span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="email" className="input-label">
              {t("email")}
              <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="email"
              placeholder={t("enterEmail")}
              className={`input-field ${errors.email ? "input-error" : ""}`}
              value={formData?.email || ""}
              onChange={handleChange}
            />
            {errors.email && (
              <span className="text-danger">{errors.email}</span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="mobile" className="input-label">
              {t("mobile")} <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              inputMode="numeric"
              placeholder={t("enterMobile")}
              className={`input-field ${errors.mobile ? "input-error" : ""}`}
              value={formData?.mobile || ""}
              onChange={handleChange}
              name="mobile"
            />
            {errors.mobile && (
              <span className="text-danger">{errors.mobile}</span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="contact_person" className="input-label">
              {t("contactPerson")} <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="contact_person"
              placeholder={t("enterContactPerson")}
              className={`input-field ${errors.contact_person ? "input-error" : ""}`}
              value={formData?.contact_person || ""}
              onChange={handleChange}
              maxLength={50}
            />
            {errors.contact_person && (
              <span className="text-danger">{errors.contact_person}</span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="gst_number" className="input-label">
              {t("gstNumber")}
            </label>
            <input
              type="text"
              name="gst_number"
              placeholder={t("enterGstNumber")}
              className={`input-field ${errors.gst_number ? "input-error" : ""}`}
              value={formData?.gst_number || ""}
              onChange={handleChange}
              maxLength={50}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="payment_terms" className="input-label">
              {t("paymentTerms")}
            </label>
            <input
              type="text"
              name="payment_terms"
              placeholder={t("enterPaymentTerms")}
              className={`input-field ${errors.payment_terms ? "input-error" : ""}`}
              value={formData?.payment_terms || ""}
              onChange={handleChange}
              maxLength={50}
            />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="store_id" className="input-label">
              {t("store")}
              <span className="text-red-500">*</span>
            </label>

            <Select
              options={storeList}
              value={
                storeList?.find((opt) => opt.value === formData.store_id) ||
                null
              }
              onChange={(selected) =>
                setFormData((prev) => ({
                  ...prev,
                  store_id: selected?.value ?? "",
                }))
              }
              styles={customStyles}
              placeholder={t("selectStore")}
              isSearchable
              isClearable
            />
            {errors.store_id && (
              <span className="text-danger">{errors.store_id}</span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="vendor_type" className="input-label">
              {t("vendorType")}
              <span className="text-red-500">*</span>
            </label>

            <Select
              options={vendorTypeOptions}
              value={
                vendorTypeOptions?.find(
                  (opt) => opt.value === formData.vendor_type,
                ) || null
              }
              onChange={(selected) =>
                setFormData((prev) => ({
                  ...prev,
                  vendor_type: selected?.value ?? "",
                }))
              }
              styles={customStyles}
              placeholder="Select category"
              isSearchable
              isClearable
            />
            {errors.vendor_type && (
              <span className="text-danger">{errors.vendor_type}</span>
            )}
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="store_id" className="input-label">
              {t("vendorStatus")}
            </label>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={formData.status === 1}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    status: e.target.checked ? 1 : 0,
                  }))
                }
              />
              <div className="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-brand-orange/20 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[4px] after:start-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-brand-gradient shadow-inner"></div>
            </label>
          </div>
        </div>

        <div className="col-span-full flex items-end justify-end gap-4 mb-20 lg:mb-0 mt-4">
          {" "}
          <button
            className="btn-filter-close"
            onClick={() => {
              navigate("/vendor");
            }}
          >
            {t("back")}
          </button>
          <button
            type="button"
            form="category-form"
            className="btn-submit-orange flex items-center gap-2 mb-1"
            onClick={handleSubmit}
            disabled={btnLoading}
          >
            {btnLoading && (
              <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
            )}
            {btnLoading
              ? t("submitting")
              : formData.uuid
                ? t("update")
                : t("submit")}
          </button>
        </div>
      </section>
    </div>
  );
};

export default AddVendor;
